module.exports = __webpack_public_path__ + "img/5.a0fac09a.png";